import { canv } from "@/canv/global";
import { getViewport } from "@/canvasController/helpers";
import type { ExtractText } from "@/elements/arrow/types";
import { TextWidgetV2 } from "@/elements/text/textV2";
import type { WidgetStateMap } from "@/elements/text/typesV2";

export class LineTextItem {
    constructor(positionShare: number) {
        this.positionShare = positionShare;

        this.text = new TextWidgetV2();

        this.text.setKeepMinWidth(false);
        this.text.menuTextAlign("center");
        this.text.setEditingAutosaveHandler(false);
        this.updateTextPosition();
    }

    isOver() {
        const pt = canv.actionManager.getActionPoint();
        const x = pt.x;
        const y = pt.y;

        if (!this.text) return;

        if (
            x >= this.x - this.text.width / 2 &&
            x <= this.x + this.text.width / 2 &&
            y >= this.y - this.text.height / 2 &&
            y <= this.y + this.text.height / 2
        ) {
            return true;
        }

        return false;
    }

    clip(draw = false) {
        if (!this.text) return;
        const viewport = getViewport();
        // рисуем вправо, вниз, влево, вверх

        // Левый прямоугольник
        canv.ctx.beginPath();
        canv.ctx.moveTo(viewport.viewportStartX, viewport.viewportStartY);
        canv.ctx.lineTo(this.x - this.text.width / 2, viewport.viewportStartY);
        canv.ctx.lineTo(
            this.x - this.text.width / 2,
            viewport.viewportStartY + viewport.viewportHeight,
        );
        canv.ctx.lineTo(viewport.viewportStartX, viewport.viewportStartY + viewport.viewportHeight);
        canv.ctx.lineTo(viewport.viewportStartX, viewport.viewportStartY);

        // правый прямоугольник
        canv.ctx.moveTo(this.x + this.text.width / 2, viewport.viewportStartY);
        canv.ctx.lineTo(viewport.viewportStartX + viewport.viewportWidth, viewport.viewportStartY);
        canv.ctx.lineTo(
            viewport.viewportStartX + viewport.viewportWidth,
            viewport.viewportStartY + viewport.viewportHeight,
        );
        canv.ctx.lineTo(
            this.x + this.text.width / 2,
            viewport.viewportStartY + viewport.viewportHeight,
        );
        canv.ctx.lineTo(this.x + this.text.width / 2, viewport.viewportStartY);

        // верхний прямоугольник
        canv.ctx.moveTo(this.x - this.text.width / 2, viewport.viewportStartY);
        canv.ctx.lineTo(this.x + this.text.width / 2, viewport.viewportStartY);
        canv.ctx.lineTo(this.x + this.text.width / 2, this.y - this.text.height / 2);
        canv.ctx.lineTo(this.x - this.text.width / 2, this.y - this.text.height / 2);
        canv.ctx.lineTo(this.x - this.text.width / 2, viewport.viewportStartY);

        // нижний прямоугольник
        canv.ctx.moveTo(this.x - this.text.width / 2, this.y + this.text.height / 2);
        canv.ctx.lineTo(this.x + this.text.width / 2, this.y + this.text.height / 2);
        canv.ctx.lineTo(
            this.x + this.text.width / 2,
            viewport.viewportStartY + viewport.viewportHeight,
        );
        canv.ctx.lineTo(
            this.x - this.text.width / 2,
            viewport.viewportStartY + viewport.viewportHeight,
        );
        canv.ctx.lineTo(this.x - this.text.width / 2, this.y + this.text.height / 2);

        canv.ctx.clip();

        if (draw) {
            const memStroke = canv.ctx.strokeStyle;
            canv.ctx.strokeStyle = this.color;
            canv.ctx.stroke();
            canv.ctx.strokeStyle = memStroke;
        }
    }

    draw() {
        if (!this.text) return;
        this.text.draw();
    }

    updateTextPosition() {
        if (!this.text) return;
        this.text.startX = this.x - this.text.width / 2;
        this.text.startY = this.y - this.text.height / 2 + this.text.lineHeight;

        if (!this.text.getIsEditing()) {
            this.text.updateDims();
        }
    }

    get(): ExtractText | null {
        if (!this.text) return null;
        return {
            positionShare: this.positionShare,
            text: this.text.getState("full") as WidgetStateMap["full"],
        };
    }

    x = 0;
    y = 0;
    positionShare = 0.5;
    text: TextWidgetV2 | null = null;
    color = "black";
}
